import { useEffect, useState } from 'react';
import { ArrowRight } from 'lucide-react';

interface TermsAcceptanceProps {
  value: boolean;
  onChange: (value: boolean) => void;
}

export default function TermsAcceptance({
  onChange,
}: TermsAcceptanceProps) {
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [privacyAccepted, setPrivacyAccepted] = useState(false);

  useEffect(() => {
    onChange(termsAccepted && privacyAccepted);
  }, [termsAccepted, privacyAccepted, onChange]);

  return (
    <div
      style={{
        marginTop: '8px',
        padding: '14px',
        borderRadius: '16px',
        background: '#f8fafc',
        border: '1px solid #e2e8f0',
        display: 'flex',
        flexDirection: 'column',
        gap: '14px',
      }}
    >
      {/* TERMINOS */}
      <div>
        <label
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: '12px',
            cursor: 'pointer',
          }}
        >
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '10px',
            }}
          >
            <input
              type="checkbox"
              checked={termsAccepted}
              onChange={(e) => setTermsAccepted(e.target.checked)}
              style={{
                width: '16px',
                height: '16px',
              }}
            />

            <span
              style={{
                fontSize: '14px',
                color: '#334155',
              }}
            >
              Acepto los{' '}
              <span
                style={{
                  color: '#2563eb',
                  fontWeight: 600,
                }}
              >
                términos y condiciones
              </span>
            </span>
          </div>

          <a
            href="https://wingdrive.com.co/terminos-y-condiciones"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '4px',
              color: '#2563eb',
              fontWeight: 600,
              textDecoration: 'none',
              fontSize: '13px',
              whiteSpace: 'nowrap',
            }}
          >
            Ver
            <ArrowRight size={14} />
          </a>
        </label>

        <p
          style={{
            margin: '6px 0 0 26px',
            fontSize: '12px',
            color: '#64748b',
            lineHeight: 1.5,
          }}
        >
          Autorizo que he leído y aceptado los términos y condiciones de uso de la plataforma.
        </p>
      </div>

      {/* PRIVACIDAD */}
      <div>
        <label
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: '12px',
            cursor: 'pointer',
          }}
        >
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '10px',
            }}
          >
            <input
              type="checkbox"
              checked={privacyAccepted}
              onChange={(e) => setPrivacyAccepted(e.target.checked)}
              style={{
                width: '16px',
                height: '16px',
              }}
            />

            <span
              style={{
                fontSize: '14px',
                color: '#334155',
              }}
            >
              Acepto la{' '}
              <span
                style={{
                  color: '#2563eb',
                  fontWeight: 600,
                }}
              >
                política de privacidad
              </span>
            </span>
          </div>

          <a
            href="https://wingdrive.com.co/politica-de-privacidad"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '4px',
              color: '#2563eb',
              fontWeight: 600,
              textDecoration: 'none',
              fontSize: '13px',
              whiteSpace: 'nowrap',
            }}
          >
            Ver
            <ArrowRight size={14} />
          </a>
        </label>

        <p
          style={{
            margin: '6px 0 0 26px',
            fontSize: '12px',
            color: '#64748b',
            lineHeight: 1.5,
          }}
        >
          Autorizo el tratamiento de mis datos personales de acuerdo con la política de privacidad.
        </p>
      </div>
    </div>
  );
}